// extracted by mini-css-extract-plugin
export default {"buttons":"homepage-team_buttons__T0kZ4","button":"homepage-team_button__W2Y9J","selected":"homepage-team_selected__JPhMb","underline":"homepage-team_underline__Clp33"};